exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".bg-image {\n  width: 100%;\n  height: 100%;\n  overflow: hidden; }\n  .bg-image img {\n    min-width: 100%;\n    min-height: 100%; }\n\n.cover-card-element {\n  width: 75vw;\n  border-left: 30px solid #fff;\n  border-right: 30px solid #fff;\n  border-top: 30px solid #fff;\n  border-bottom: 15px solid #fff; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/components/cover-card/cover-card.component.scss
// module id = 185
// module chunks = 1